import React, { useRef, useState } from 'react'

type Props = {
  className?: string
  fullText: string | React.ReactNode
  shortText: string | React.ReactNode
}

const ReadMoreToggle: React.FC<Props> = ({ className, fullText, shortText }) => {
  const detailsRef = useRef(null)

  const clickHandler = () => {
    if (detailsRef.current) {
      detailsRef.current.open = false
    }
    toggleSummary()
  }

  const [showSummary, setShowSummary] = useState<boolean>(true)

  const toggleSummary = () => setShowSummary(!showSummary)

  return (
    <div className="read-more-toggle">
      <details ref={detailsRef} className={className}>
        <summary style={{ visibility: showSummary ? 'visible' : 'hidden' }} onClick={toggleSummary}>
          {shortText}
        </summary>
        <span onClick={clickHandler}>{fullText}</span>
      </details>
    </div>
  )
}

export default ReadMoreToggle
